<template>
  <div>
    <v-autocomplete
      :items="items"
      :loading="loading"
      item-text="site_description"
      item-value="site_description"
      clearable
      :value="value"
      @input="value => $emit('input', value)"
      :label="component.label"
      :search-input.sync="search"
      :menu-props="{ contentClass: 'icd-autocomplete' }"
      no-filter
      hide-no-data
      :hint="icdoCode"
      persistent-hint
    >
      <template v-slot:item="data">
        <template>
          <span class="my-1"> {{ data.item.site_description }} </span>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    component: { type: Object },
    diagnosisTopography: { type: String, default: () => '' }
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null
    }
  },
  computed: {
    icdoCode() {
      const icdocode = this.items.find(
        ({ site_description }) => site_description == this.value
      )
      return icdocode ? icdocode.site_recode : ''
    }
  },

  watch: {
    search(newval) {
      if (newval && newval !== this.value) {
        this.items = []
        this.querySelections(newval)
      }
    }
  },

  created() {
    if (this.value) {
      this.search = this.value
    }
  },
  methods: {
    async querySelections(query) {
      this.loading = true
      const res = await fetch(
        `${
          process.env.VUE_APP_API_URL
        }/content/icdoTopography?queryString=${query}`
      )
      const data = await res.json()
      this.items = data
      this.loading = false
    }
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
</style>
